import clsx from "classnames";
import classes from "./styles.module.scss";
import HeaderTitle from "@/components/HeaderTitle";
import ContactButton from "@/components/ContactButton";

export default function ConsultantProfile({ consultant, className }) {
 
  return (
    <div className={clsx(className, classes.profile)}>
      <div className={classes.left_section}>
        <img alt={consultant.name} src={consultant.profile_image} className={classes.profile_image}></img>
        <div className={classes.contact}>
          <span className={classes.label}>get in touch</span>
          <div className={classes.socials}>
            <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={"mailto:" + consultant.email} icon={"/icons/envelope.png"} alt="envelope"></ContactButton>
            <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={"tel:" + consultant.phone} icon={"/icons/call.png"} alt="call"></ContactButton>
            <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={consultant.linkedin} icon={"/icons/linkedin.png"} alt="linkedin"></ContactButton>
          </div>
        </div>
      </div>
      <div className={classes.right_section}>
        <div className={classes.specialisms}>
          <div className={classes.name}>
            <HeaderTitle title={consultant.name}/>          
          </div> 
          {
            consultant.specialisms &&
            <>
              <div className={classes.label}>Specialisms:</div>
              <div className={classes.tags}>
                {consultant.specialisms ? consultant.specialisms.map((specialism, index) => (
                  <div key={index} className={classes.item}>{specialism}</div>
                )) : <></>}  
              </div>
            </>
          }
        </div>        
        <div className={classes.description}>
          <div dangerouslySetInnerHTML={{ __html: consultant?.description }} />
        </div>        
      </div>
    </div>
  );
}

ConsultantProfile.defaultProps = {
  className: "",
};
